import { withStyles } from '@material-ui/core/styles';
import StyledCheckbox from './StyledCheckbox';
import styles from './StyledCheckbox.styles';

export default withStyles(styles)(StyledCheckbox);
